import { PlaybackControls } from "@/components/carousel/components/playback-controls";
import { HotkeyConfigButton } from "@/components/hotkey-config-modal";
import { ConnectDeviceModal } from "@/components/integrated-devices/connect-device-modal";
import { Page } from "@/components/page";
import { ExitButton } from "@/components/exit-button";
import { FullScreenButton } from "@/components/full-screen-button";
import { AppShell, Flex } from "@mantine/core";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_subscribed/play")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page title="Game">
      <AppShell
        h="100%"
        styles={{
          main: {
            height: "100%",
          },
        }}
        header={{
          height: 50,
        }}
      >
        <AppShell.Header>
          <Flex justify="space-between" p="xs">
            <Flex h="100%" justify="flex-start" align="center" gap="md">
              <ExitButton />
            </Flex>
            <Flex gap="sm" align="center">
              <HotkeyConfigButton />
              <ConnectDeviceModal size="icon" />
              <PlaybackControls />
              <FullScreenButton />
            </Flex>
          </Flex>
        </AppShell.Header>
        <AppShell.Main>
          <Outlet />
        </AppShell.Main>
      </AppShell>
    </Page>
  );
}
